export default __webpack_public_path__ + "static/media/Broadcasting.ecdc3a08.png";